﻿import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'formatnumber',
    pure: true
})
@Injectable()
export class FormatNumberPipe implements PipeTransform {
    transform(number: any): any {

        if (number === undefined || number === null)
            return "";
    
        return this.numberWithCommas(Number(number).toFixed(2).replace(".", ","));
    }

    numberWithCommas(x: string) {
        var parts = x.toString().split(",");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    }
}